import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { AuthType } from '@/const/auth';
import { Auth } from '@/interface';
import { fetchAuthList, fetchWoaUserInfo } from '@/services/auth';
import { isWoa } from '@/utils/getApiDomain';

export interface AuthState {
  authData?: Auth;
  loading: boolean;
  woaUser?: string;
  hasPICAuth?: boolean;
  hasAVGAuth?: boolean;
  noUgcAuth?: boolean;
}

const initialState: AuthState = {
  loading: !isWoa,
};

export const getAuthList = createAsyncThunk('auth/list', fetchAuthList);
export const getWoaUser = createAsyncThunk('auth/woaUser', fetchWoaUserInfo);

const isHasAuth = (authKeys: string[], authData: Auth) => {
  const hasAuth = authKeys?.some(key => key === authData?.type);
  return hasAuth;
};

export const auth = createSlice({
  name: 'auth',

  initialState,

  reducers: {
  },
  extraReducers: (builder) => {
    builder.addCase(getAuthList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAuthList.fulfilled, (state, { payload }) => {
      const authKeys2 = [AuthType.PIC, AuthType.ADMIN, AuthType.CMS, AuthType.PIC_UGC];
      const hasPICAuth = isHasAuth(authKeys2, payload?.data);

      const authKeys1 = [AuthType.UGC, AuthType.ADMIN, AuthType.CMS, AuthType.PIC_UGC];
      const hasAVGAuth = isHasAuth(authKeys1, payload?.data);

      state.authData = payload?.data;
      state.hasPICAuth = hasPICAuth;
      state.hasAVGAuth = hasAVGAuth;
      state.noUgcAuth = !hasAVGAuth && !hasPICAuth;
      state.loading = false;
    });
    builder.addCase(getWoaUser.fulfilled, (state, { payload }) => {
      state.woaUser = payload;
    });
  },
});


export default auth.reducer;
